import React, { PureComponent, Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { HOTEL, PATHS } from '../../../../../constants/Define';
import i18n from '../../../../../constants/initLng';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import { withTranslation } from "react-i18next";
import { Icon, message, Popconfirm, Tooltip } from 'antd';
import { DragSource, DropTarget } from 'react-dnd';
import Ripple from '../../../common/component/Ripple';
import Rate from '../../../../../models/Rate';
import { FlagIcons, FlagIconsRatePlan } from '../../../common/component/TranslateButton';
import _, { isEqual } from 'lodash';
import './style.less'
import EllipsisText from '../../../common/component/EllipsisText';
import { dataCustomerAction } from '../../../../../actions/customerAction';
import CONFIG from '../../../../../constants/Config';
import { RATE_SYNC_RATES_ACTION } from '../../../../../constants/Types';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';
import { faRecordVinyl } from '@fortawesome/free-solid-svg-icons';
import AutoTranslateModal from './Components/AutoTranslateModal';
import Modal from '../../../common/component/Modal';
import moment from 'moment';

const ListCols = ['id', 'code', 'typeRate', 'dc', 'name', 'description', 'promotions', 'shortDescription', 'dayOfWeek', 'usageStatus', 'isIndependent', 'status', 'isActive', 'order', 'isExtend', 'translations'];
const ListColsWithBeachVilla = ['id', 'code', 'name', 'description', 'dayOfWeek', 'isActive', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new Rate());

let dragingIndex = -1;
const TIME_FORMAT = 'HH:mm';

class BodyRow extends React.Component {
    render() {
      const { isOver, connectDragSource, connectDropTarget, moveRow, getListRates, ...restProps } = this.props;
      const style = { ...restProps.style, cursor: 'move' };
      let { className } = restProps;
      if (isOver) {
        if (restProps.index > dragingIndex) {
          className += ' drop-over-downward';
        }
        if (restProps.index < dragingIndex) {
          className += ' drop-over-upward';
        }
      }

      return connectDragSource(
        connectDropTarget(<tr {...restProps} className={className} style={style} />),
      );
    }
}

class RateList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            itemRow: {},
            modelItem: ModelFields,
            filters: {},
            dataListRate: [],
            selectedFields: [],
            headSelectedIndex: 0,
            firstSelectedIndex: 0
        };
    }

    clearItemSelection() {
      this.setState({ selectedFields: [], headSelectedIndex: 0, firstSelectedIndex: 0 });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dataList && !isEqual(nextProps.dataList, this.props.dataList)) {
            this.setState({ dataListRate: nextProps.dataList });
            this.clearItemSelection();
        }
        if(!nextProps.isSort || !isEqual(nextProps.isSort, this.props.isSort)){
          this.clearItemSelection();
        }
    }

    componentDidMount() {
    }

    rowSource = {
        beginDrag(props) {
          let dragFields;
          let headSelect;
          if (props.selectedFields.find(field => field.id === props.record.id)) {
            dragFields = props.selectedFields;
            headSelect = props.headSelectedIndex;
          } else {
            dragFields = [props.record];
            headSelect = props.index;
          }
          return {
            index: props.index,
            dragFields: dragFields,
            headSelectedIndex: headSelect
          };
        },
    };

    rowTarget = {
        drop(props, monitor) {
          const dragIndex = monitor.getItem().index;
          const dragFields = monitor.getItem().dragFields;
          const headSelect = monitor.getItem().headSelectedIndex;
          const hoverIndex = props.index;
          if (dragIndex === hoverIndex) {
            return;
          }
          props.moveRow(hoverIndex, dragFields, headSelect);
          monitor.getItem().index = hoverIndex;
        },
      };

    DragableBodyRow = DropTarget('row', this.rowTarget, (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
      }))(
        DragSource('row', this.rowSource, connect => ({
          connectDragSource: connect.dragSource(),
        }))(BodyRow),
      );

    components = {
        body: {
          row: this.DragableBodyRow,
        },
    };

    async handleRowSelection(shiftKey, index) {
      this.handleItemSelection(index, shiftKey)
    }

    handleItemSelection(index, shiftKey) {
      let { firstSelectedIndex } = this.state;
      let selectedFields;
      const fields = this.state.dataListRate;
      const field = index < 0 ? '' : fields[index];
      const lastSelectedIndex = index;
      if (!shiftKey) {
        this.setState({firstSelectedIndex: index, headSelectedIndex: index});
        selectedFields = [field];
      } else if (shiftKey) {
        if(index > firstSelectedIndex){
          selectedFields = [].concat(fields.slice(this.state.firstSelectedIndex, index + 1));
          this.setState({headSelectedIndex: firstSelectedIndex});
        }else{
          selectedFields = [].concat(fields.slice(index, this.state.firstSelectedIndex + 1));
          this.setState({headSelectedIndex: index});
        }
      }
      const finalList = fields ? fields
        .filter(f => selectedFields.find(a => a === f)) : [];
      this.setState({ selectedFields: finalList });
    }

    onUpdateActive = (value, data)=> {
      this.props.onUpdateRateActive({
        res: {
          id: data.id,
          data: {isActive: value}
        },
        name: data.name
      });
    }

    onUpdateExtend = (value, data) => {
      this.props.onUpdateRateExtend({
        res: {
          id: data.id,
          data: {isExtend: value}
        },
        name: data.name
      })
    }

    onUpdateIndependent = (value, data) => {
      this.props.onUpdateRateExtend({
        res: {
          id: data.id,
          data: {isIndependent: value}
        },
        name: data.name
      })
    }

    parseTimeToMinutes = (time) => {
      if (!time) return null;
      const [hours, minutes] = `${time}`.split(':').map(Number);
      if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
      return hours * 60 + minutes;
    }

    isOperatingHourMatched = (operatingHours = [], filterTime) => {
      if (filterTime === 'all') return true;
      const selectedMinutes = this.parseTimeToMinutes(filterTime);
      if (selectedMinutes === null) return true;

      return (operatingHours || []).some(item => {
        if (!item?.isActive) return false;
        const startMinutes = this.parseTimeToMinutes(item.startTime);
        const endMinutes = this.parseTimeToMinutes(item.endTime);
        if (startMinutes === null || endMinutes === null) return false;
        return selectedMinutes >= startMinutes && selectedMinutes <= endMinutes;
      });
    }

    renderOperatingHours = (operatingHours = []) => {
      const content = (operatingHours || [])
        .filter(item => item?.isActive)
        .map(item => `${item.startTime} - ${item.endTime}`)
        .join(', ');

      if (!content) return '';

      return (
        <EllipsisText
          title={content}
          content={content}
          contentMaxWidth={240}
          overlayClassName={'max-width-500'}
          overlayComponent={Tooltip}
        />
      );
    }

    render() {
      const { loading, isSort, moveRow, isBeachVilla, pagination } = this.props;
      const { modelItem, dataListRate, selectedFields, headSelectedIndex } = this.state;
      const activeFilteredValue = this.props.filters?.isActive !== undefined
        ? [(Array.isArray(this.props.filters.isActive) ? this.props.filters.isActive[0] : this.props.filters.isActive).toString()]
        : null;
      
      const titleItemTable = isBeachVilla ?
        Func.getTitleTable(ListColsWithBeachVilla, ['action'], ['id', 'shortDescription']) :
        Func.getTitleTable(ListCols, ['action'], ['id', 'shortDescription', 'dc'])
      
      const createComponentTable = (isBeachVilla) => {
        let componentTable = {
          typeRate: {
            key: 'DC',
            align: 'center',
            width: 150,
            className: 'rate-list-cell-nowrap',
            filters: [
              { value: Object.entries(HOTEL.TYPE_RATE[CONFIG.ENV])[0][0], text: this.props.t(`item.rate.filters.hotel`) },
              { value: Object.entries(HOTEL.TYPE_RATE[CONFIG.ENV])[1][0], text: this.props.t(`item.rate.filters.bundle`) },
            ],
            render: (text, record) => record.dc &&
              <div className="rate-list-type-rate">
                {record.dc.map(typeId =>
                  <StatusComponent
                      color={HOTEL.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red'}
                      label={HOTEL.TYPE_RATE[CONFIG.ENV][typeId]}
                  />
                )}
              </div>
          },
          name: {
            key: 'name',
            width: 220,
            className: 'rate-list-cell-ellipsis',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <HMS.FilterDropdown
                setSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
              >
              </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
              <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) =>
              <EllipsisText title={text} content={text} contentMaxWidth={200}
                overlayClassName={'max-width-500'} overlayComponent={Tooltip}
              />
          },
          code: {
            key: 'code',
            width: 160,
            align: 'center',
            className: 'rate-list-cell-nowrap rate-list-cell-code',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <HMS.FilterDropdown
                setSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
              >
              </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
              <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text) => (
              <EllipsisText
                title={text}
                content={text}
                contentMaxWidth={140}
                overlayClassName={'max-width-500'}
                overlayComponent={Tooltip}
              />
            ),
          },
          description: {
            key: 'description',
            width: isBeachVilla ? 320 : 260,
            className: 'rate-list-cell-ellipsis',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <HMS.FilterDropdown
                setSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
              >
              </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
              <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (text, record) =>
              <EllipsisText title={text} content={text} contentMaxWidth={240}
                overlayClassName={'max-width-500'} overlayComponent={Tooltip}
              />
          },
          dayOfWeek: {
            key: 'dayOfWeek',
            width: 260,
            className: 'rate-list-cell-ellipsis',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
              const normalizedSelectedKeys = Array.isArray(selectedKeys) ? selectedKeys : [];
              const isAllDayActive = normalizedSelectedKeys[0] === 'all';
              const selectedTime = !isAllDayActive && normalizedSelectedKeys[0]
                ? moment(normalizedSelectedKeys[0], TIME_FORMAT)
                : null;

              return (
              <div style={{ padding: 8, width: 180 }}>
                <ANT.TimePicker
                  allowClear
                  format={TIME_FORMAT}
                  inputReadOnly
                  minuteStep={1}
                  value={selectedTime}
                  onChange={(time) => setSelectedKeys(time ? [time.format(TIME_FORMAT)] : [])}
                  style={{ width: '100%', marginBottom: 8 }}
                />
                <div className="d-flex justify-content-between">
                  <ANT.Button
                    type={isAllDayActive ? 'primary' : 'default'}
                    size="small"
                    onClick={() => { setSelectedKeys(['all']); confirm(); }}
                  >
                    All day
                  </ANT.Button>
                  <ANT.Button type="primary" size="small" onClick={() => confirm()}>
                    {this.props.t('action.search')}
                  </ANT.Button>
                  <ANT.Button size="small" onClick={() => { clearFilters(); confirm(); }}>
                    {this.props.t('action.cancel')}
                  </ANT.Button>
                </div>
              </div>
            )},
            filterIcon: filtered => (
              <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) => this.isOperatingHourMatched(record.operatingHours, value),
            render: (text, record) => this.renderOperatingHours(record.operatingHours),
          },
          promotions: {
            key: 'promotions',
            width: 220,
            className: 'rate-list-cell-ellipsis',
            render: (promotions, record) => {
              let text = '';
              if (promotions) {
                text = promotions.join(', ')
              }
              return <EllipsisText title={text} content={text} contentMaxWidth={200} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
            }
          },
          usageStatus: {
            key: 'usageStatus',
            width: 120,
            className: 'rate-list-cell-nowrap',
            filters: [
              { value: true, text: this.props.t(`item.rate.filters.activeUsage`) },
              { value: false, text: this.props.t(`item.rate.filters.deActiveUsage`) },
            ],
            render: (status, record) =>
              <StatusComponent color={status ? 'green' : 'red'}
                label={status ? this.props.t('item.rate.filters.activeUsage') : this.props.t('item.rate.filters.deActiveUsage')}
              />
          },
          isIndependent: {
            key: 'isIndependent',
            width: 130,
            className: 'rate-list-cell-nowrap',
            render: (isExtend, record) =>
              <FlagIconsRatePlan
                languages={record.translations.filter(translate => !!translate.isIndependent)}
              />
          },
          status: {
            key: 'status',
            width: 120,
            className: 'rate-list-cell-nowrap',
            filters: [
              { value: true, text: this.props.t(`item.rate.filters.active`) },
              { value: false, text: this.props.t(`item.rate.filters.deActive`) },
            ],
            render: (status, record) =>
              <StatusComponent color={status ? 'green' : 'red'}
                label={status ? this.props.t('item.rate.active') : this.props.t('item.rate.deactive')}
              />
          },
          isActive: {
            width: isBeachVilla ? 110 : 120,
            key: 'isActive',
            className: 'rate-list-cell-nowrap',
            filteredValue: activeFilteredValue,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <HMS.FilterRadioDropdown
                selectedKeys={selectedKeys}
                setSelectedKeys={setSelectedKeys}
                confirm={confirm}
                dataFilters={[
                  { value: '__all__', text: 'All status' },
                  { value: 'true', text: this.props.t(`item.rate.filters.active`) },
                  { value: 'false', text: this.props.t(`item.rate.filters.deActive`) },
                ]}
                handleReset={() => {
                  clearFilters();
                  confirm();
                }}
                defaultValue="__all__"
              />
            ),
            filterIcon: filtered => (
              <ANT.Icon type="filter" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            render: (isActive, record) => {
              return (
                <ANT.Switch
                  checkedChildren={this.props.t('item.rate.filters.active')}
                  unCheckedChildren={this.props.t('item.rate.filters.deActiveShort')}
                  checked={isActive}
                  style={{ width: '100%' }}
                  loading={this.props.loadingStatus}
                  onChange={value => this.onUpdateActive(value, record)}
                />
              )
            }
          },
          order: {
            key: 'order',
            width: 90,
            align: 'center',
            className: 'rate-list-cell-nowrap',
          },
          isExtend: {
            key: 'isExtend',
            width: 130,
            className: 'rate-list-cell-nowrap',
            render: (isExtend, record) => {
              return (
                <ANT.Switch
                  checkedChildren={this.props.t('item.rate.onIsExtend')}
                  unCheckedChildren={this.props.t('item.rate.offIsExtend')}
                  checked={isExtend}
                  style={{ width: '100%' }}
                  loading={this.props.loadingExtendRate}
                  onChange={value => this.onUpdateExtend(value, record)}
                />
              )
            }
          },
          translations: {
            key: 'translations',
            width: 150,
            className: 'rate-list-cell-nowrap',
            align: isBeachVilla && 'center',
            render: (text, record) => <FlagIconsRatePlan
              languages={record.translations}
            />,
          },
          action: {
            width: isBeachVilla ? 180 : 130,
            align: 'center',
            key: 'action',
            className: 'rate-list-cell-nowrap rate-list-cell-action',
            render: (text, record) => this.renderEditComponent(record),
          }
        }

        if (isBeachVilla) {
          delete componentTable.typeRate;
          delete componentTable.usageStatus;
          delete componentTable.isExtend;
          delete componentTable.status;
          delete componentTable.promotions;
          delete componentTable.isIndependent;
        }

        return componentTable;
      }

      const componentTable = createComponentTable(isBeachVilla);
      
        return (
            <ListComponent
                tableKey="hotel-rate-list"
                scroll={{ x: isBeachVilla ? 1400 : 1900 }}
                rowClassName={(record, index) => selectedFields.findIndex(item => item.id === record.id) > -1 && 'table-row-light'}
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(dataListRate || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'rate'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.pageIndex, pageSize: pagination.pageSize }}
                componentTableList={{}}
                components={isSort && this.components}
                onRow={(record, index) => ({
                    record,
                    index,
                    moveRow,
                    onClick: (e) => isSort && this.handleRowSelection(e.shiftKey, index),
                    selectedFields,
                    headSelectedIndex
                })}
            />
        );
    }

    syncRate = (hotelId) => {
      this.props.syncRates(hotelId)
    }

    renderEditComponent(item) {
        const { t, permisions, hotelId } = this.props;
        const onChangeTranslate = (item) => {
          this.setState({itemRow: item })
        }
        const handleCancel = () => {
            this.setState({itemRow: {} })
        }
        return (
            <div className="rate-list-action-group">
              { permisions && permisions.allowUpdate && !_.isEmpty(this.state.itemRow) && this.state.itemRow.id === item.id  && <AutoTranslateModal  getListRates={this.props.getListRates} item={item} handleCancel={() => handleCancel()}/>}
                <Ripple>
                  <Icon type="global" style={{padding: '0 10px'}} className="fs20" onClick={() => onChangeTranslate(item)}/>
                </Ripple>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={Func.getPathWithParams(PATHS.RATE.DETAIL.path, { hotel_id: hotelId, id: item.id })} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
            </div>
        )
    }
}

export default withTranslation()(RateList);
